import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { getAmountSearchTagLabel } from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = {
  index: number;
};

export const AmountSearchTypeTag: FC<Props> = ({ index }) => {
  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({ control, name: 'sheetType' });
  const fiscalYear = useWatch({ control, name: 'fiscalYear' });
  const formulaConditions = useWatch({
    control,
    name: 'formulaConditions',
  });

  if (!formulaConditions || !formulaConditions[index]) {
    return null;
  }

  const label = getAmountSearchTagLabel({
    formulaCondition: formulaConditions[index],
  });

  if (sheetType !== 'RS' || !fiscalYear || !label) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={label}
      onClose={() => {
        setValue(
          'formulaConditions',
          formulaConditions.filter((_, i) => i !== index),
        );
      }}
    />
  );
};
